import TableHeadings from '../../../components/Common-components/table-headings'
import { Spinner } from '../../../components/Common-components/spinner'
import { useUserReport } from '../hook/useUserReport'
import { Pagination } from '../../../components/Pagination'
import { useTranslation } from 'react-i18next'
import { UserReportFilters } from '../component/userReportFilters'

export const TopEngagedUsers = () => {
    const { t } = useTranslation()
    const { data, methods } = useUserReport()
    const { topEngagedUserTableHead, details, loader, controller, totalCount } = data
    const { handlePagination } = methods
    return (
        <>
            {loader && <Spinner />}
            <section className="filter">
                <UserReportFilters data={data} methods={methods} />
            </section>{' '}
            <div className="table-responsive custom_table px-2 flex-fill mt-3 custom_scroll">
                <table className="table cus-table mt-3">
                    <TableHeadings removeTr={true} TableHeadData={topEngagedUserTableHead} />
                    <tbody>
                        {details?.length ? (
                            details?.map((row, index) => (
                                <tr className="fw-4 font-12" key={row?._id}>
                                    <td align="center">{controller?.rowsPerPage * (controller?.page - 1) + index + 1}</td>
                                    <td align="center">{row?.name || '- -'}</td>
                                    <td align="center">{row?.contactNumber || '- -'}</td>
                                    <td align="center">{row?.email || '- -'}</td>
                                    <td align="center">{row?.totalAmount || '- -'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={12} align="center">
                                    {t('tableTitle.noRecordFound')}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
            {totalCount > 10 && (
                <div>
                    <Pagination count={totalCount} controller={controller} setController={handlePagination} />
                </div>
            )}
        </>
    )
}
